import axios from "axios";
import { ADMIN_PORTAL_AUTH_TOKEN, ADMIN_PORTAL_API_BASE_URL } from "../utils/config";

export const deletePromptQuestion = async (payload) => {
    let config = {
        method: "post",
        url: `${ADMIN_PORTAL_API_BASE_URL}/delete_prompt_questions`,
        data: payload,
        headers: {
            Authorization: "Bearer " + ADMIN_PORTAL_AUTH_TOKEN
        }
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}